// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3Kwyb","footer":"ModalCreateQualiphyProcedure_footer__1gABJ","additionData":"ModalCreateQualiphyProcedure_additionData__JZ4no"};